(function () {
  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  function init() {
    let allImages = [];
    let currentIndex = 0;

    // Overlay aufbauen
    const overlay = document.createElement('div');
    overlay.id = 'sidekick-lightbox';

    const img = document.createElement('img');
    const closeBtn = document.createElement('button');
    closeBtn.id = 'lb-close';
    closeBtn.innerHTML = '&times;';
    closeBtn.onclick = closeLightbox;

    const prevBtn = document.createElement('button');
    prevBtn.id = 'lb-prev';
    prevBtn.innerHTML = '&#8592;';
    prevBtn.onclick = () => navigate(-1);

    const nextBtn = document.createElement('button');
    nextBtn.id = 'lb-next';
    nextBtn.innerHTML = '&#8594;';
    nextBtn.onclick = () => navigate(1);

    const counter = document.createElement('div');
    counter.id = 'lb-counter';

    overlay.append(img, closeBtn, prevBtn, nextBtn, counter);
    document.body.appendChild(overlay);

    overlay.addEventListener('click', e => { if (e.target === overlay) closeLightbox(); });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') navigate(-1);
      if (e.key === 'ArrowRight') navigate(1);
    });

    function getFullSrc(el) {
      return (el.currentSrc || el.src)
        .replace(/_([\d]+x[\d]*|[\d]*x[\d]+)\./i, '.')
        .split('?')[0];
    }

    function openLightbox(index) {
      currentIndex = index;
      img.src = allImages[currentIndex];
      counter.textContent = `${currentIndex + 1} / ${allImages.length}`;
      overlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      prevBtn.style.display = allImages.length > 1 ? 'block' : 'none';
      nextBtn.style.display = allImages.length > 1 ? 'block' : 'none';
    }

    function navigate(dir) {
      currentIndex = (currentIndex + dir + allImages.length) % allImages.length;
      img.src = allImages[currentIndex];
      counter.textContent = `${currentIndex + 1} / ${allImages.length}`;
    }

    function closeLightbox() {
      overlay.style.display = 'none';
      document.body.style.overflow = '';
    }

    function setup() {
      const gallery = document.querySelector('.product-information__media .media-gallery__grid');
      if (!gallery) return;
      if (document.getElementById('lb-all-images-tile')) return;

      // Alle Bilder sammeln
      const imgEls = gallery.querySelectorAll('img');
      allImages = Array.from(imgEls).map(getFullSrc);

      if (allImages.length <= 3) {
        // Weniger als 4 Bilder: normale Lightbox ohne Kachel
        imgEls.forEach((el, i) => {
          if (el.dataset.lb) return;
          el.dataset.lb = '1';
          el.style.cursor = 'zoom-in';
          el.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            openLightbox(i);
          });
        });
        return;
      }

      // Erste 3 Bilder: Lightbox beim Klick
      Array.from(imgEls).slice(0, 3).forEach((el, i) => {
        if (el.dataset.lb) return;
        el.dataset.lb = '1';
        el.style.cursor = 'zoom-in';
        el.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          openLightbox(i);
        });
      });

      // 4. Kachel: "Alle Bilder" Button
      const tile = document.createElement('div');
      tile.id = 'lb-all-images-tile';
      tile.innerHTML = `
        <span class="count">+${allImages.length - 3}</span>
        <span>Alle Bilder</span>
      `;
      tile.addEventListener('click', () => openLightbox(3));
      gallery.appendChild(tile);
    }

    setup();
    new MutationObserver(setup).observe(document.body, { childList: true, subtree: true });
  }
})();

